import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import OrganizationAddButton from "@/modules/organization/organization-add-button";
import { OrganizationsListProvider } from "@/modules/organizations/organizations-list-provider";
import { OrganizationsListTable } from "@/modules/organizations/organizations-list-table";

const { Content } = Layout;

const Organizations = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:organizations")} />
      <Content>
        <OrganizationsListProvider storageKey={STORAGE_KEYS.ORGANIZATIONS}>
          <OrganizationsListTable extraActions={<OrganizationAddButton />} />
        </OrganizationsListProvider>
      </Content>
    </>
  );
};

export default Organizations;
